import Explora from './Explora'
export default Explora